import React, { FC, useState, useCallback } from 'react';

import { SubtitlesList } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Tracks/Subtitles/SubtitlesList';
import { usePreparedTextTracks } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Tracks/Subtitles/hooks/usePreparedTextTracks';
import { Option } from '@/scenarios/legacy-player/components/PlayerSkin/parts/OptionList';
import { useTextTracks } from '@/scenarios/legacy-player/hooks/useTextTracks';
import { useCurrentTextTrack } from '@/scenarios/legacy-player/hooks/useCurrentTextTrack';
import { TextTrack } from '@/scenarios/legacy-player/types/instance';

import { SubtitlesConfig } from '../../../../Player';

import { useIsSubtitlesToggleEnabled } from './hooks/use-is-subtitles-toggle-enabled';

interface Props {
    subtitles: SubtitlesConfig;
    forceSubtitle?: boolean;
    onSelectTextTrack: (track: TextTrack) => void;
}

export const SubtitlesListContainer: FC<Props> = ({
    onSelectTextTrack,
    subtitles,
    forceSubtitle,
}) => {
    const textTracksRaw = useTextTracks();
    const currentTextTrack = useCurrentTextTrack();

    const [showAll, setShowAll] = useState(false);

    const { textTracks, hasInvisibleByDefault } = usePreparedTextTracks({
        textTracksRaw: textTracksRaw ?? [],
        showAll,
        subtitles,
        isSubtitlesToggleEnabled: useIsSubtitlesToggleEnabled(forceSubtitle),
    });

    const handleSelectTextTrack = useCallback(
        (trackOption: Option<string>) => {
            const track = textTracks.find((textTrack) => textTrack.value === trackOption.value);
            if (track) {
                const { name, value, lang } = track;
                onSelectTextTrack({ name, value, lang });
            }
        },
        [onSelectTextTrack, textTracks]
    );

    return (
        <SubtitlesList
            currentTextTrack={currentTextTrack}
            textTracksWithDisableOption={textTracks}
            handleSelectTextTrack={handleSelectTextTrack}
            hasMoreSubtitles={!showAll && hasInvisibleByDefault}
            showAllSubtitles={() => setShowAll(true)}
        />
    );
};
